import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a curtain set for a 1 m window, against the z=0 wall plane:
// a matte-black rod at 2.35 m with sphere finials, and two gathered fabric
// panels (two slightly offset boxes each) hanging to near the floor.
const BLACK = "#2e2e30";
const FABRIC = "#e8e0d2";

const ROD_Y = 2.35;
const ROD_Z = 0.09;
const PANEL_TOP = 2.32;
const PANEL_BOTTOM = 0.06;
const PANEL_H = PANEL_TOP - PANEL_BOTTOM;

/** One gathered curtain panel: two slightly offset boxes for a wavy read. */
function panel(x: number): Part[] {
  return [
    { geometry: new THREE.BoxGeometry(0.14, PANEL_H, 0.05), color: FABRIC,
      position: [x - 0.05, PANEL_BOTTOM + PANEL_H / 2, ROD_Z - 0.02] },
    { geometry: new THREE.BoxGeometry(0.12, PANEL_H, 0.05), color: FABRIC,
      position: [x + 0.06, PANEL_BOTTOM + PANEL_H / 2, ROD_Z + 0.02] },
  ];
}

export const windowCurtains = defineModel({
  id: "window-curtains",
  batchId: "modern",
  name: "Window curtains",
  tags: ["modern", "interior", "fixture", "decor", "window", "curtains"],
  summary: "A curtain rod with two gathered fabric panels for a 1 m window.",
  description:
    "Mounts against the z=0 wall plane over a 1 m window piece: a matte-black " +
    "rod at 2.35 m with end finials and two fabric panels hanging to near the " +
    "floor at the window's sides.",
  tiles: { w: 1, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    return [
      // Rod along X, standing off the wall.
      { geometry: new THREE.CylinderGeometry(0.015, 0.015, 1.1, 8), color: BLACK,
        position: [0, ROD_Y, ROD_Z], rotation: [0, 0, Math.PI / 2] },
      // End finials.
      { geometry: new THREE.SphereGeometry(0.03, 8, 6), color: BLACK,
        position: [-0.56, ROD_Y, ROD_Z] },
      { geometry: new THREE.SphereGeometry(0.03, 8, 6), color: BLACK,
        position: [0.56, ROD_Y, ROD_Z] },
      // Gathered panels at the window's sides.
      ...panel(-0.42),
      ...panel(0.42),
    ];
  },
  animations: [],
});
